import { properCallApi, type ApiResponseSingle, type ApiRequest, type ApiResponse } from '../tenantClient';

export const tempRegistrationsQueryKey = 'registration.tempRegistrations';

/**
 * This needs to match what's returned from the backend.
 */
export interface TempRegistration {
  id: number
  firstName: string
  lastName: string
  email: string
  disabled?: boolean
  // groupRegistrationId: number
}

export interface TempRegistrationsByGroupRegistrationQuery {
  groupRegistrationId: number
}

export function loadTempRegistrationsByGroupRegistration(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: TempRegistrationsByGroupRegistrationQuery
  ): Promise<ApiResponse<TempRegistration>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/temporary_registrations/by_group_registration';
    request.endpoint.query = {
      groupRegistrationId: params.groupRegistrationId,
    };
    return await properCallApi<ApiResponse<TempRegistration>>(request);
  };
}

export interface TempRegistrationSaveItem extends Omit<TempRegistration, 'id'> {
  id?: number
  groupRegistrationId: number
}

export interface TempRegistrationSaveRequest {
  temporaryRegistration: TempRegistrationSaveItem
  eventId: string
}

export function saveTempRegistration(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: TempRegistrationSaveRequest
  ): Promise<ApiResponseSingle<TempRegistration>> => {
    if (params.temporaryRegistration.id) {
      request.method = 'PUT';
      request.endpoint.path = '/api/v1/temporary_registrations/' + params.temporaryRegistration.id;
      request.payload = params;
    } else {
      request.method = 'POST';
      request.endpoint.path = '/api/v1/temporary_registrations';
      request.payload = params;
    }
    return await properCallApi<ApiResponseSingle<TempRegistration>>(request);
  };
}

export interface TempRegistrationDeleteRequest {
  id: number
}

export function deleteTempRegistration(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: TempRegistrationDeleteRequest
  ): Promise<ApiResponseSingle<{}>> => {
    request.method = 'DELETE';
    request.endpoint.path = '/api/v1/temporary_registrations/' + params.id.toString();
    return await properCallApi<ApiResponseSingle<{}>>(request);
  };
}
